import { Occ } from "@spartacus/core";
import { UserSignUp } from '@spartacus/user/profile/root';
import { Observable } from 'rxjs';
import User = Occ.User;

export abstract class CustomDocumentIdentifierValidatorAdapter {
  abstract documentIdentifierValidator(user: UserSignUp): Observable<User>;
}
